import { motion } from "framer-motion";
import { Home, MessageSquare, FolderOpen, User } from "lucide-react";

const navItems = [
  { id: "home", icon: Home, label: "Home" },
  { id: "chats", icon: MessageSquare, label: "Chats" },
  { id: "library", icon: FolderOpen, label: "Library" },
  { id: "profile", icon: User, label: "Profile" }
];

/**
 * NexiBottomNav - Bottom navigation bar
 * Fixed: Uses safe-area-inset for iPhone home indicator
 */
const NexiBottomNav = ({ activeTab = "home", onTabChange }) => {
  return (
    <motion.nav
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      className="fixed bottom-0 left-0 right-0 z-50"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div 
        className="mx-3 mb-2 rounded-2xl bg-[#0A0D1B]/95 backdrop-blur-2xl border border-slate-800/50 shadow-2xl"
      >
        <div className="flex items-center justify-around px-2 py-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeTab === item.id;
            
            return (
              <motion.button
                key={item.id}
                onClick={() => onTabChange(item.id)}
                className={`relative flex flex-col items-center gap-1 px-6 py-2 rounded-xl transition-all ${
                  isActive 
                    ? 'text-cyan-400' 
                    : 'text-slate-500 hover:text-slate-300'
                }`}
                whileTap={{ scale: 0.95 }}
                data-testid={`nav-${item.id}`}
                style={{ WebkitTapHighlightColor: 'transparent' }}
              >
                {/* Active indicator */}
                {isActive && (
                  <motion.div
                    layoutId="activeTab"
                    className="absolute inset-0 bg-cyan-500/10 rounded-xl border border-cyan-500/20"
                    transition={{ type: "spring", stiffness: 500, damping: 30 }}
                  />
                )}
                
                <Icon size={20} className="relative z-10" />
                <span className="relative z-10 text-[10px] font-medium">{item.label}</span>
              </motion.button>
            );
          })}
        </div>
      </div>
    </motion.nav>
  );
};

export default NexiBottomNav;
